import { CheckedAddress } from '@sparkdotfi/common-universal'

import { useSignReferralCodeData } from './useSignReferralCodeData'
import { useSubmitReferralCodeSignature } from './useSubmitReferralCodeSignature'

export interface ConnectReferralCodeArgs {
  account: CheckedAddress
  referralCode: string
}

interface UseConnectReferralCodeParams {
  onSuccess: () => Promise<void>
  onError: () => void
}

interface UseConnectReferralCodeResult {
  isPending: boolean
  error: Error | null
  reset: () => void
  connectReferralCode: (args: ConnectReferralCodeArgs) => Promise<void>
}

export function useConnectReferralCode({
  onError,
  onSuccess,
}: UseConnectReferralCodeParams): UseConnectReferralCodeResult {
  const {
    mutateAsync: signReferralCodeData,
    isPending: isSigning,
    error: signingError,
    reset: resetSigning,
  } = useSignReferralCodeData({ onError })

  const {
    mutateAsync: submitReferralCode,
    isPending: isSubmitting,
    error: submittingError,
    reset: resetSubmitting,
  } = useSubmitReferralCodeSignature({ onError })

  return {
    connectReferralCode: async (args) => {
      try {
        const signature = await signReferralCodeData(args)
        await submitReferralCode({ ...args, signature })
        await onSuccess()
      } catch {
        // error handled via error property
      }
    },
    isPending: isSigning || isSubmitting,
    error: signingError || submittingError,
    reset: () => {
      resetSigning()
      resetSubmitting()
    },
  }
}
